import { useContext } from "react";
import { Spinner } from "../../../components";
import AuthContext from "../../../context/AuthContext";
import { ToolsRunAdmin } from "./ToolsRunAdmin";
import { ToolsRunClient } from "./ToolsRunClient";

export const ToolsRunPage = () => {
  const { idRole, isLoading } = useContext(AuthContext);
  if (isLoading) return <Spinner />;
  return idRole === 3 ? <ToolsRunClient /> : <ToolsRunAdmin />;
};
